/* STEP 3 · rule 7 — dates and periods (owner 26-Oct-2026). B-7e: Analytics names its own fixed cut-off window
   (each head-folder cut-off worksheet keeps its own setting). EN + AR. Loaded from lib/i18n/ by the generated index. */
export const I18N_S3R7 = {
  en: {
    s3r7: {
      analyticsCutoffWindow: "Revenue entries {days} days either side of the period end ({from} to {to}) — Analytics' own fixed window; each cut-off worksheet uses its own setting.",
    },
  },
  ar: {
    s3r7: {
      analyticsCutoffWindow: "قيود الإيرادات خلال {days} أيام قبل نهاية الفترة وبعدها ({from} إلى {to}) — فترة ثابتة خاصة بالتحليلات؛ تستخدم كل ورقة عمل للفصل الزمني إعدادها الخاص.",
    },
  },
};

export default I18N_S3R7;
